import { AssistantType } from '~/consts/assistant-types';

const assitants = [
  AssistantType.E_MOBILITY,
  AssistantType.SOLAR,
  AssistantType.HEATING,
  AssistantType.COMBI,
];

export default assitants;
